/**
 *
 * Search Service Selectors
 *
 */

import { createSelector } from 'reselect/lib';
import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';
import { formatters, REQUIRED_EXTERNAL_PERMISSIONS } from 'common';
import { authorization } from 'apex-legit-service';
import { NAMESPACE } from './constants';

const selectService = (state) => state ? state[NAMESPACE] : {};

const selectStatus = createSelector(selectService, (service) => service.status);

const selectParams = createSelector(selectService, (service) => service.params);

const selectResults = createSelector(selectService, (service) => service.results);

const searchParams = createSelector(selectService, (service) => service.params);

const nextPageToken = createSelector(selectService, (service) => service.nextPageToken);

const previousPageToken = createSelector(selectService, (service) => service.previousPageToken);

const totalSize = createSelector(selectService, (service) => service.totalSize);

const selectResultsCount = createSelector(selectService, (service) => {
  const { results } = service;
  if (isArray(results)) {
    return results.length;
  }
  return 0;
});

const selectResultsAmountTotal = createSelector(selectService, (service) => {
  if (isArray(service.results)) {
    return formatters.formatDollars(service.results
      .filter((result) => isNumber(result.amount))
      .reduce((acc, result) => acc + result.amount, 0));
  }
  return formatters.formatDollars(0);
});

const selectError = createSelector(selectService, (service) => service.error);

const selectSearchShowAllFields = (state) => {
  const domain = state[authorization.NAMESPACE];
  if (!domain.results) return false;
  const { results: { permissions } } = domain;

  return REQUIRED_EXTERNAL_PERMISSIONS.some((rolePermission) =>
    permissions.some((permission) =>
      permission.request.permission === rolePermission && permission.permitted
    )
  );
};

export {
  selectStatus,
  selectParams,
  selectResults,
  selectResultsCount,
  selectResultsAmountTotal,
  selectError,
  selectSearchShowAllFields,
  previousPageToken,
  nextPageToken,
  searchParams,
  totalSize,
};



// WEBPACK FOOTER //
// ./src/services/search/selectors.js